import { requestDELETE, requestGET, requestPOST, requestPUT } from "../HttpRequestHelpers";


// DTO with queryDb info
// status code [notallowed] + reason "no_singup" or not_authenticated or "not_authorized"
// OR
// status code 200 + {
//   max_total_count: 123
//   total_count: 111
//   question: "Select your T-Shirt!"
//   options: ["xs", "s", "m"]
//   queries: [{answer_id?, signup_id?, Name?, old_answer? }]
// }
export enum FailReasonE {
    NO_SIGNUP="NO_SIGNUP",                  // Missing signups for this user
    NOT_AUTHENTICATED="NOT_AUTHENTICATED",  // Requires login
    MAX_ANSWER_COUNT_REACHED="MAX_ANSWER_COUNT_REACHED", // 
    ANSWER_DEADLINE_REACHED="ANSWER_DEADLINE_REACHED", // 
}

export interface Query {
    answerId: null | number;
    signupId: null | number;
    signupName: null | string;
    answer: null | string; // Old answer comming in here too
}

// Always respond with response 200 if query found but perhaps with empty queries array and some error
export interface QueryResponseDto_GET {
  max_total_count: number | null;
  total_count: number;
  question: string;       // "Select your T-Shirt!"
  options: Array<string>; // ["xs", "s", ...]
  queries: Array<Query>;
  error: FailReasonE | null;
  updatable: boolean;
  requiredCompetitionId: number | null;
  requiredDisciplineId: Array<number>;
  lastAnswerTimeInMs: number | null;
}

export interface QueryDto_PUT_POST{
  max_total_count: number | null;
  signupRequiredToCompetitionId: number | null;
  signupRequiredToDisciplineIds: Array<number>;
  question: string;       // "Select your T-Shirt!"
  options: Array<string>; // ["xs", "s", ...]
  lastAnswerTimeInMs: number | null;
}

export interface AnswerDto_PUT_POST {
  // authAs:   <-- NO, it is taken from the security context!
  queryId: number;
  signupId: number | null;
  answer: string;
}


export const QueryClient = {
    getQuery: async (queryId: number) => {
            return await requestGET<QueryResponseDto_GET>(
                `/api/posts/query/${queryId}`
            );
    },

    postQuery: async (queryDto: QueryDto_PUT_POST) => {
            const response = await requestPOST<{queryId: number}>( `/api/posts/query`, queryDto);
            const queryId = response.body ?? null;
            return queryId;
    },

    putQuery: async (queryId: number, queryDto: QueryDto_PUT_POST) => {
            await requestPUT<{queryId:number}>( `/api/posts/query/${queryId}`, queryDto);
    },

    postAnswer: async (answer: AnswerDto_PUT_POST) => {
        return await requestPOST<{status: string}>(`/api/posts/query/answer`, answer);
    },

    putAnswer: async (answer: AnswerDto_PUT_POST, answerId : number) => {
        return await requestPUT<{status: string}>(`/api/posts/query/answer/${answerId}`, answer);
    },

    deleteAnswer: async (answerId: number) => {
        return await requestDELETE<{status: string}>(`/api/posts/query/answer/${answerId}`);
    }
}